import { render } from "./SetPassword.vue?vue&type=template&id=87170198&scoped=true"
import script from "./SetPassword.vue?vue&type=script&lang=js"
export * from "./SetPassword.vue?vue&type=script&lang=js"

import "./SetPassword.vue?vue&type=style&index=0&id=87170198&lang=less&scoped=true"

import exportComponent from "/root/workspace/want-ceo-backstage-management/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87170198"]])

export default __exports__